<script lang="ts">
  import { defineComponent } from "vue";
  import SectionEtablissementApprentiAbstract from '@/generated/sections/SectionEtablissementApprentiAbstract.vue';
  export default defineComponent({
    extends: SectionEtablissementApprentiAbstract,
    components: {}
  })
</script>
